// 主题模式
export const STORAGE_KEY_THEME_MODE = `admin-theme-mode`;

export const STORAGE_KEY_POS_PRIMARY_ESCPOS_PRINTER = `pos-primary-escpos`;
export const STORAGE_KEY_POS_PRIMARY_ESCPOS_PRINTER_CONFIG = `pos-primary-escpos-config`;

export const STORAGE_KEY_POS_PRIMARY_TSPL_PRINTER = `pos-primary-tspl`;
export const STORAGE_KEY_POS_PRIMARY_TSPL_PRINTER_CONFIG = `pos-primary-tspl-config`;

// 界面配置
export const STORAGE_KEY_POS_UI_CONFIG = `pos-ui-config`;

// 下单配置
export const STORAGE_KEY_POS_ORDER_CONFIG = `pos-order-config`;

export const STORAGE_KEY_DEVICE_PARAM_SCANNER_DELAY = `device-param-scanner-delay`;

const POS_HOTKEYS_PREFIX = `pos-hotkeys-`;
export const STORAGE_POS_HOTKEYS_OPEN_CASH_DRAW = `${POS_HOTKEYS_PREFIX}open-cash-draw`;
export const STORAGE_POS_HOTKEYS_GOTO_WORKBENCH = `${POS_HOTKEYS_PREFIX}goto-workbench`;
export const STORAGE_POS_HOTKEYS_GOTO_ORDER = `${POS_HOTKEYS_PREFIX}goto-order`;
export const STORAGE_POS_HOTKEYS_GOTO_USER = `${POS_HOTKEYS_PREFIX}goto-user`;
export const STORAGE_POS_HOTKEYS_GOTO_SETTING = `${POS_HOTKEYS_PREFIX}goto-setting`;
export const STORAGE_POS_HOTKEYS_GOTO_LAUNCHER = `${POS_HOTKEYS_PREFIX}goto-launcher`;

export const STORAGE_POS_HOTKEYS_GOTO_RELOAD = `${POS_HOTKEYS_PREFIX}reload`;

export const STORAGE_POS_LOGIN_HISTORY = `pos-login-history`;

export const STORAGE_KEY_COMMAND_HISTORY = `pos-command-history`;
export const STORAGE_KEY_COMMAND_MAX_ITEMS = 50;

